"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscordAuthResponseToJSON = exports.DiscordAuthResponseFromJSONTyped = exports.DiscordAuthResponseFromJSON = void 0;
function DiscordAuthResponseFromJSON(json) {
    return DiscordAuthResponseFromJSONTyped(json, false);
}
exports.DiscordAuthResponseFromJSON = DiscordAuthResponseFromJSON;
function DiscordAuthResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'url': json['url'],
    };
}
exports.DiscordAuthResponseFromJSONTyped = DiscordAuthResponseFromJSONTyped;
function DiscordAuthResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'url': value.url,
    };
}
exports.DiscordAuthResponseToJSON = DiscordAuthResponseToJSON;
